var map = {
	"./baseline-print_disabled-24px.svg": "8a39",
	"./bastet.png": "4935",
	"./calendar.png": "2cc6",
	"./donation.png": "7627",
	"./gift.png": "5d49",
	"./gift2.png": "26ec",
	"./gift3.png": "68d6",
	"./google-maps.png": "4a9d",
	"./grocery.png": "abf9",
	"./happy.png": "6d5d",
	"./heart-box.png": "a31c",
	"./house.png": "1495",
	"./icons8-apple-jam-96.png": "5427",
	"./icons8-basket-96.png": "dbda",
	"./icons8-berry-jam-96.png": "a78b",
	"./icons8-calendar-128.png": "dc7c",
	"./icons8-cardboard-box-128.png": "01e9",
	"./icons8-crown-96.png": "95e9",
	"./icons8-detective-128.png": "1b62",
	"./icons8-empty-jam-jar-96.png": "6590",
	"./icons8-gift-128.png": "d55d",
	"./icons8-jam-128.png": "2bb1",
	"./icons8-jam-96.png": "dbd8",
	"./icons8-qr-code-128.png": "9442",
	"./icons8-search-128.png": "7889",
	"./icons8-shopping-bag-128.png": "8ab3",
	"./icons8-shopping-bag-128_white.png": "90e1",
	"./icons8-shopping-bag-96.png": "5f1b",
	"./icons8-shopping-basket-128.png": "0fb0",
	"./icons8-shutdown-128.png": "26e6",
	"./icons8-small-business-96.png": "43c5",
	"./icons8-wedding-gift-128.png": "1d27",
	"./icons8-wedding-gift-96.png": "d7ae",
	"./icons8-wicker-basket-96.png": "5e66",
	"./jar.png": "bd95",
	"./login.png": "07a6",
	"./logo.png": "cf05",
	"./logout.png": "bc8c",
	"./market.png": "44fa",
	"./pointing-right.png": "d747",
	"./shop.png": "0173",
	"./sunrise.svg": "61e0",
	"./weekly-calendar.png": "6c23"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";